export default "__VITE_ASSET__kA$Jl0w$__"